import React from 'react'
import PropTypes from 'prop-types'
import VehicleDetailsVertical from './VehicleDetailsVertical/VehicleDetailsVertical'
import VehicleDetailsHorizontal from './VehicleDetailsHorizontal/VehicleDetailsHorizontal'
import { VehicleInfo } from './style'

function VehicleCardNewCar(props) {
  const {
    name,
    version,
    price,
    year,
    image,
    href,
    experience,
    isHorizontal,
  } = props

  return (
    <VehicleInfo>
      {isHorizontal ? (
        <VehicleDetailsHorizontal
          name={name}
          version={version}
          price={price}
          year={year}
          href={href}
          experience={experience}
          image={image}
        />
      ) : (
          <VehicleDetailsVertical
            name={name}
            version={version}
            price={price}
            year={year}
            href={href}
            experience={experience}
            image={image}
          />
        )}
    </VehicleInfo>
  )
}

VehicleCardNewCar.defaultProps = {
  isHorizontal: false,
  name: null,
  version: null,
  price: null,
  year: null,
  image: null,
  href: '#',
  experience: 'PRICE',
}

VehicleCardNewCar.propTypes = {
  isHorizontal: PropTypes.bool,
  name: PropTypes.string,
  version: PropTypes.string,
  price: PropTypes.string,
  year: PropTypes.string,
  href: PropTypes.string,
  image: PropTypes.string,
  experience: PropTypes.string,
}

export default VehicleCardNewCar
